import * as React from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap';
import KPDropdown from '../../../BaseTemplate/SSPCustomComponentLibrary/KPDropdown/KPDropdown';
import { handleNextStep, setQuoteData } from '../../../../actions/salesActions';
import { postToController } from '../../../../actions/apiActions';
import './VehicleMakeAndModel.css';

class VehicleMakeAndModel extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            regNo: this.props.sales.regNr,
            lookupCorrect: (this.props.sales.regNr && this.props.sales.regNr.toString().trim().length > 0),
            yearItems: [],
            year: this.props.sales.vehicleYear ? this.props.sales.vehicleYear.toString() : "",
            searchItems: [],
            selectedItem: { fullDescription: this.props.sales.vehicleFullDescription ? this.props.sales.vehicleFullDescription : "" },
            vehicleMakeId: this.props.sales.vehicleMakeId,
            vehicleModelId: this.props.sales.vehicleModelId,
            vehicleSeriesId: this.props.sales.vehicleSeriesId,
            mmCode: this.props.sales.mmCode,
            nextDisabled: true
        }

        this.checkSubmit = this.checkSubmit.bind(this);
        this.handleCloseButNo = this.handleCloseButNo.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);

        this.handleLstYearChange = this.handleLstYearChange.bind(this);
        this.autocomplete = this.autocomplete.bind(this);
        this.hanldeKeyup = this.hanldeKeyup.bind(this);
        this.hanldeKeydown = this.hanldeKeydown.bind(this);
    }

    async componentDidMount() {
        if (this.state.yearItems.length === 0) {
            let yearItems: any = [];
            for (let i = 0; i < 20; i++) {
                let year = new Date().getFullYear() - i;
                yearItems.push({ id: year.toString(), productName: "Year", description: year.toString() });
            }
            this.setState({ yearItems });
        }

        this.checkSubmit();
    }

    async checkSubmit() {
        let valid = (this.state.year > 0 && this.state.selectedItem?.fullDescription?.length > 0);
        await this.setState({ nextDisabled: !valid });
    }

    async handleCloseButNo() {
        await this.setState({ lookupCorrect: false });
    }

    async handleNextStep() {
        if (!this.state.nextDisabled) {
            let payload = {
                vehicleYear: this.state.year.toString(),
                vehicleFullDescription: this.state.selectedItem.fullDescription,
                vehicleMakeId: this.state.vehicleMakeId,
                vehicleSeriesId: this.state.vehicleSeriesId,
                vehicleModelId: this.state.vehicleModelId,
                mmCode: this.state.mmCode,
            }
            await this.props.dispatchAction(setQuoteData(payload));
            await this.props.dispatchAction(handleNextStep());
        }
    }

    async handleLstYearChange(e: any) {
        await this.setState({ year: e });
        await this.checkSubmit();
    }

    async autocomplete(evt) {
        let text = evt.target.value;
        const listmax = 50;   //Make the search quicker - can't return full list
        let items = [];
        await this.setState({ selectedItem: text, searchItems: [] });

        if (text && text.length >= 3 && this.state.year !== "") {
            await postToController(this.props.dispatch, 'VehicleSearch', JSON.stringify({ Year: parseInt(this.state.year), SearchText: text }))
                .then(async (response) => {
                    if (response !== "Failure") {
                        items = response
                            .filter((i, index) => (index < listmax))
                            .map((i, index) => {
                                return (i);
                            });
                        await this.setState({ searchItems: items });
                    }
                });
        }
        await this.checkSubmit();
    }

    hanldeKeyup(evt) {
        if (evt.keyCode === 27) {
            this.setState({ searchItems: [] });
            return false;
        }
    }

    hanldeKeydown(evt) {
        const { cursor, searchItems } = this.state;
        // arrow up/down button should select next/previous list element
        if (evt.keyCode === 38 && cursor > 0) {
            this.setState(prevState => ({
                cursor: prevState.cursor - 1
            }));
        } else if (evt.keyCode === 40 && cursor < searchItems.length - 1) {
            this.setState(prevState => ({
                cursor: prevState.cursor + 1
            }));
        }
        if (evt.keyCode === 13) {
            let currentItem = searchItems[cursor];
            if (currentItem !== undefined) {
                this.setState({ searchItems: [] });
            }
        }
    }

    async selectItem(item) {
        await this.setState({ selectedItem: item, vehicleMakeId: item.vehicleMake.id, vehicleModelId: item.vehicleModel.id, vehicleSeriesId: item.vehicleSeries.id, mmCode: item.vehicleSeries.mmCode });
        await this.setState({ searchItems: [] });
        await this.checkSubmit();
    }

    public render() {
        let headerMsg = this.state.lookupCorrect ? "This is what we managed to find under your registration number." : "Please give us the year, make, and model of your car.";

        return (
            <div className="container">
                <p className="text-center">
                    {headerMsg}
                </p>

                <div className="form-row mt-4">
                    <div className="col-12">
                        <div className="form-group">
                            {this.state.lookupCorrect && 
                                <>
                                    <Form.Label className="left-align temp-text-box-label pl-1">Year</Form.Label>
                                    <Form.Control type="text" placeholder="Year" id="YearInputId" name="year" value={this.props.sales.vehicleYear} disabled />
                                </>
                            }

                            {!this.state.lookupCorrect &&
                                <KPDropdown
                                    id={"lstYear"}
                                    className={"ssp-popup-dropdown"}
                                    label={"Year"}
                                    labelAfterSelection={"Year"}
                                    showLabelAfterSelection={true}
                                    showLabelInside={false}
                                    showLabelOutside={true}
                                    data={this.state.yearItems}
                                    handleSelection={(e) => this.handleLstYearChange(e)}
                                    selectedValue={this.state.year}
                                />
                            }
                        </div>
                    </div>

                    <div className="col-12 mt-1">
                        <div className="form-group">
                            <Form.Label className={"left-align temp-text-box-label pl-1" + (this.state.selectedItem.fullDescription !== "" ? "" : " no-opacity")}>Make and model</Form.Label>

                            {this.state.lookupCorrect &&
                                <Form.Control type="text" placeholder="Make and model" id="DescriptionInputId" name="description" value={this.props.sales.vehicleFullDescription} disabled />
                            }

                            {!this.state.lookupCorrect &&
                                <>
                                    <input
                                    type="text"
                                    id="autocomplete"
                                    onChange={this.autocomplete}
                                    onKeyUp={this.hanldeKeyup}
                                    onKeyDown={this.hanldeKeydown}
                                    value={this.state.selectedItem.fullDescription}
                                    className="custom-input form-control"
                                    placeholder="Make and model"
                                    disabled={this.state.year === ""}
                                    />

                                    {this.state.searchItems.length > 0 && (
                                        <div className="makeAndModelList">
                                            <ul className="list-group">
                                                {this.state.searchItems.map((item, idx) => (
                                                    <li
                                                        className={
                                                            this.state.cursor === idx ? "active list-group-item" : "list-group-item"
                                                        }
                                                        key={idx}
                                                        onClick={() => this.selectItem(item)}
                                                    >
                                                        {item.fullDescription}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </>
                            }
                        </div>
                    </div>
                </div>

                <div className="row mt-lg-4">
                    {this.state.lookupCorrect &&
                        <>
                            <div className="col-md-6 text-right">
                                <button type="button" className="btn btn-outline-red btnNavigate mt-4 mt-lg-0" onClick={this.handleCloseButNo}>Close, but no</button>
                            </div>

                            <div className="col-md-6 text-left">
                                <button type="button" className="btn btn-solid-red btnNavigate mt-4 mt-lg-0" disabled={this.state.nextDisabled} onClick={this.handleNextStep}>Yes, you’ve got it</button>
                            </div>
                        </>
                    }
                    {!this.state.lookupCorrect &&
                        <>
                            <div className="col-12 justify-content-center">
                                <button type="button" className="btn btn-solid-red btnNavigate mt-4 mt-lg-0" disabled={this.state.nextDisabled} onClick={this.handleNextStep}>Next</button>
                            </div>
                        </>
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleMakeAndModel);